import {
  type AccessControl,
  createAccessControl,
} from "better-auth/plugins/access";
import {
  adminAc,
  defaultStatements,
  memberAc,
  ownerAc,
} from "better-auth/plugins/organization/access";

export const statement = { ...defaultStatements } as const;

export const ac: AccessControl = createAccessControl(statement);

export const owner = ac.newRole({ ...ownerAc.statements });
export const admin = ac.newRole({ ...adminAc.statements });

/**
 * Overrides better-auth's default `member` role to allow members to invite
 * teammates and cancel pending invitations. All other resources stay
 * restricted to owners and admins.
 */
export const member = ac.newRole({
  ...memberAc.statements,
  invitation: ["create", "cancel"],
});

export const roles = { owner, admin, member };
